import { CommonModal } from "@components/CommonModal/CommonModal";
import { InputShowTooltip } from "@components/InputShowTooltip/InputShowTooltip";
import { ArrowLeftIcon } from "@constants/svgs";
import { MODAL_TYPE } from "@utils/constants";
import { Input, Select } from "antd";
import React from "react";
import { MAX_LENGTH_5, MAX_LENGTH_50 } from "../constant";

interface ICommonSectorModalProps {
  FIELDS_CONFIG: any;
  state: any;
  handler: any;
  translate: any;
  FORM_MODAL: any;
}

const LARGE_MODAL_WIDTH = 800;
const SMALL_MODAL_WIDTH = 416;

const LARGE_WIDTH_MODAL_TYPES = [
  MODAL_TYPE.DETAIL,
  MODAL_TYPE.UPDATE,
  MODAL_TYPE.REGISTRATION,
  MODAL_TYPE.CONFIRM_UPDATE,
  MODAL_TYPE.CONFIRM_REGISTRATION,
];

const getModalWidth = (modalType: string) =>
  LARGE_WIDTH_MODAL_TYPES.includes(modalType)
    ? LARGE_MODAL_WIDTH
    : SMALL_MODAL_WIDTH;

const isCompanySelectDisabled = (disableField: boolean, modalType: string) =>
  disableField || modalType === MODAL_TYPE.UPDATE;

const renderModalTitleBackButton = (
  commonSectorModal: any,
  handler: any,
  translate: any
) => {
  if (commonSectorModal.modalType === MODAL_TYPE.CONFIRM_REGISTRATION) {
    return (
      <button
        onClick={() =>
          handler.setCommonSectorModal({
            ...commonSectorModal,
            disableField: false,
            modalType: MODAL_TYPE.REGISTRATION,
            title: translate("SECTOR_PAGE.SECTOR_REGISTRATION"),
          })
        }
      >
        <ArrowLeftIcon />
      </button>
    );
  }
  if (commonSectorModal.modalType === MODAL_TYPE.CONFIRM_UPDATE) {
    return (
      <button
        onClick={() =>
          handler.setCommonSectorModal({
            ...commonSectorModal,
            disableField: false,
            modalType: MODAL_TYPE.UPDATE,
            title: translate("SECTOR_PAGE.SECTOR_UPDATE"),
          })
        }
      >
        <ArrowLeftIcon />
      </button>
    );
  }
  return null;
};

const CommonSectorModal: React.FC<ICommonSectorModalProps> = (props) => {
  const { FIELDS_CONFIG, state, handler, translate, FORM_MODAL } = props;

  return (
    <div>
      {state.commonSectorModal.visible && (
        <CommonModal
          isLoading={state.loadingModal}
          width={getModalWidth(state.commonSectorModal.modalType)}
          form={state.formModal}
          isCloseIcon={false}
          isMaskClosable={false}
          isDisableBtnNext={state.disableBtnNext}
          title={
            <>
              {renderModalTitleBackButton(
                state.commonSectorModal,
                handler,
                translate
              )}
              <span>{state.commonSectorModal.title}</span>
            </>
          }
          visible={state.commonSectorModal.visible}
          modalType={state.commonSectorModal.modalType}
          handleValidateForm={handler.handleValidateForm}
          handleOpenModalConfirmFinal={handler.handleOpenModalConfirmFinal}
          handleFinalAction={handler.handleFinalAction}
          onClose={() => {
            handler.setCommonSectorModal({
              visible: false,
              modalType: "",
              title: "",
              disableField: false,
            });
          }}
          fieldData={[
            {
              fieldConfig: FIELDS_CONFIG.MODAL_COMPANY_ID,
              element: (
                <Select
                  disabled={isCompanySelectDisabled(
                    state.commonSectorModal.disableField,
                    state.commonSectorModal.modalType
                  )}
                  size="large"
                  placeholder={translate("COMMON.DROP_DOWN_PLACE_HOLDER")}
                  options={state.companiesModal}
                />
              ),
            },
            {
              fieldConfig: FIELDS_CONFIG.MODAL_SECTOR_CODE,
              element: (
                <Input
                  disabled={state.commonSectorModal.disableField}
                  placeholder={translate("COMMON.INPUT_PLACE_HOLDER")}
                  size="large"
                  onKeyDown={(event) => {
                    if (event.code === "Space") {
                      event.preventDefault();
                    }
                    if (
                      !/^[0-9]$/.test(event.key) &&
                      ![
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                        "Home",
                        "End",
                      ].includes(event.key)
                    ) {
                      event.preventDefault();
                    }
                  }}
                  maxLength={MAX_LENGTH_5}
                  onBlur={(event) => {
                    let input = event.target.value;
                    input = input.replace(/\s+/g, "");
                    state.formModal.setFieldValue(
                      FORM_MODAL.MODAL_SECTOR_CODE,
                      input
                    );
                  }}
                />
              ),
            },
            {
              fieldConfig: FIELDS_CONFIG.MODAL_SECTOR_NAME,
              element: state.isShowTooltip ? (
                <InputShowTooltip
                  title={state.formModal.getFieldValue(
                    FORM_MODAL.MODAL_SECTOR_NAME
                  )}
                />
              ) : (
                <Input
                  maxLength={MAX_LENGTH_50}
                  placeholder={translate("COMMON.INPUT_PLACE_HOLDER")}
                  disabled={state.commonSectorModal.disableField}
                  size="large"
                  onBlur={(event) => {
                    let input = event.target.value;
                    input = input.trim();
                    state.formModal.setFieldValue(
                      FORM_MODAL.MODAL_SECTOR_NAME,
                      input
                    );
                  }}
                />
              ),
            },
          ]}
        />
      )}
    </div>
  );
};

export default React.memo(CommonSectorModal);
